<template>
  <auth-layout>
    <div class="w-full md:w-3/5 sm:w-4/5 mx-auto px-3">
      <!-- <div class="my-5" v-if="verifyingToken">
        <div class="loading-area">
          <div class="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <p class="text-center">Please wait...</p>
      </div> -->

      <!-- <div class="my-4" v-if="!isValidToken">
        <p class="text-sm">
          Your reset password token has expired or is invalid.
          <router-link to="/forgot-password">Click here</router-link> to enter
          your email and get another token.
        </p>
      </div> -->

      <div>
        <div>
          <div class="">
            <h1 class="font-semibold text-lg text-center py-3">Choose a Password</h1>
            <div class="mt-2">
              <label class="label font-semibold">Password</label>
              <base-input type="password" placeholder="Enter Your Password" v-model="password">
                <template v-slot:icon>
                  <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8.45118 10.8262V12.7355M1.58551 7.64408V17.1905H15.3169V7.64408H1.58551ZM4.08212 7.64408C4.08212 3.8255 4.08212 1.27979 8.45118 1.27979C12.8202 1.27979 12.8202 3.8255 12.8202 7.64408H4.08212Z"
                      stroke="#FCC210" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </template>
              </base-input>
            </div>
            <div class="mt-2">
              <label class="label font-semibold">Confirm Password</label>
              <base-input type="password" placeholder="Confirm Your Password" v-model="password_confirmation"
                errorText="Passwords do not match!" :validation="password == password_confirmation">
                <template v-slot:icon>
                  <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8.45118 10.8262V12.7355M1.58551 7.64408V17.1905H15.3169V7.64408H1.58551ZM4.08212 7.64408C4.08212 3.8255 4.08212 1.27979 8.45118 1.27979C12.8202 1.27979 12.8202 3.8255 12.8202 7.64408H4.08212Z"
                      stroke="#FCC210" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </template>
              </base-input>
            </div>
          </div>

          <div class="shadow mt-8 px-3 py-3">
            <h1 class="font-bold text-lg">Password Requirement</h1>
            <p class="text-sm py-2">
              All passwords must satisfy these requirements. Passwords Must
              have:
            </p>
            <div class="text-sm">
              <p class="flex items-center py-1">
                <span v-if="hasUpperCase" class="pr-1">
                  <checkmark />
                </span>Must
                have at least 1 upper case character
              </p>
              <p class="flex items-center py-1">
                <span v-if="hasLowercase" class="pr-1">
                  <checkmark />
                </span>Must
                have at least 1 lower case character
              </p>

              <p class="flex items-center py-1">
                <span v-if="hasNumber" class="pr-1">
                  <checkmark />
                </span>Must
                have at least 1 number
              </p>
              <p class="flex items-center py-1">
                <span v-if="hasSpecialChars" class="pr-1">
                  <checkmark />
                </span>Must have at least 1 special character or symbol
              </p>
              <p class="flex items-center py-1">
                <span v-if="hasEightChars" class="pr-1">
                  <checkmark />
                </span>Must
                be at least 8 characters
              </p>
            </div>
          </div>
          <div class="mt-10 mb-8">
            <base-button text="Submit" width="w-full" p="px-12 py-2" @click="resetPassword" :loading="loading" />
          </div>
        </div>
      </div>
    </div>
  </auth-layout>
</template>

<script>
import AuthLayout from "../Authlayout/OnDemand";
import Checkmark from "./Checkmark.vue";

export default {
  components: {
    AuthLayout,
    Checkmark,
  },
  data() {
    return {
      password: "",
      password_confirmation: "",
      isValidToken: false,
      verifyingToken: true,
      loading: false,
    };
  },
  computed: {
    hasEightChars() {
      return this.password.length >= 8 ? true : false;
    },
    hasUpperCase() {
      return /[A-Z]/.test(this.password);
    },
    hasLowercase() {
      return /[a-z]/.test(this.password);
    },
    hasNumber() {
      return /\d/.test(this.password);
    },
    hasSpecialChars() {
      return /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(this.password);
    },
    isValidPassword() {
      return (
        this.hasEightChars &&
        this.hasUpperCase &&
        this.hasLowercase &&
        this.hasNumber &&
        this.hasSpecialChars &&
        this.password == this.password_confirmation
      );
    },
  },
  mounted() {
    //this.checkTokenValidity()
  },
  methods: {
    async resetPassword() {
      this.resettingPassword = true;
      let requestObject = {
        password: this.password,
        confirmPassword: this.password_confirmation,
        token: this.$route.query.reset_token || "",
      };

      try {
        this.loading = true;
        await this.$_resetPasswordForForgotPassword(
          requestObject
        );
        this.handleSuccessfulResponse();
        this.$router.push("/login");
      } catch (error) {
        this.resettingPassword = false;
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    handleSuccessfulResponse() {
      this.passwordIsReset = true;
      this.resettingPassword = false;
      this.generateToast(
        "Your password has been successfully reset! You can now login.",
        "success"
      );
    },
  },
};
</script>

<style scoped></style>
